var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing;
  return {
    questionColor: colors.licorice,
    questionBackgroundColor: colors.white,
    stemMargin: spacing.small
  };
};
export default generateComponentTheme;